import {
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICES_FAILURE,
  FETCH_PAYMENT_PARAMS_SUCCESS,
  FETCH_PAYMENT_STATUS_SUCCESS,
  FETCH_PAYMENT_STATUS_FAILURE,
  CHANGE_METHOD_SUCCESS,
} from '../../actions/invoice'
import Bridge from '../../utils/bridge'

const initialState = {
  invoice: null,
  invoices: {
    inProgress: [],
    cancelled: [],
    completed: [],
  },
}


const generateOrderStr = (unsortedPayParams = {}) => {
  const sortedPayParams = {}
  Object.keys(unsortedPayParams)
    .sort()
    .forEach((key) => {
      sortedPayParams[key] = unsortedPayParams[key]
    })
  return Object.entries(sortedPayParams).reduce((orderStr, [key, value], i) => {
    if (i === 0) {
      return `${key}="${value}"`
    }
    return `${orderStr}&${key}="${value}"`
  }, '')
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVOICE_SUCCESS:
      return {
        ...state,
        invoice: action.invoice,
      }
    case FETCH_INVOICES_FAILURE:
      return {
        ...state,
      }
    case FETCH_INVOICES_SUCCESS:
      if (action.offset === 0) {
        return {
          ...state,
          invoices: {
            ...state.invoices,
            [action.invoiceType]: action.invoices,
          },
        }
      }
      return {
        ...state,
        invoices: {
          ...state.invoices,
          [action.invoiceType]: [...state.invoices[action.invoiceType], ...action.invoices],
        },
      }
    case FETCH_PAYMENT_PARAMS_SUCCESS: {

      state.invoice.status = 'PAYING'
      state.invoice.payment_method = action.method

      if (action.method === 'fps_hase' && state.invoice) {
        const paymentRecord = state.invoice.payment_record ? state.invoice.payment_record : {}
        const extra = paymentRecord.extra ? { ...paymentRecord.extra, qrCode: action.pay_params_string || '' } : { qrCode: action.pay_params_string || '' }
        paymentRecord.extra = extra
        state.invoice = { ...state.invoice, payment_record: paymentRecord }
      } else if (action.method === 'payme' && state.invoice) {
        window.open(action.pay_params_string, '_blank')
      } else if ((action.method === 'paypal' || action.method === 'paypal_auth') && state.invoice) {
        window.location.replace(action.pay_params_string)
      } else if (action.method === 'edda') {
        if (action.state === 'SUCCESS') {
          state.invoice.status = 'PAID'
          Bridge.send({
            type: 'QF_PAY_STATUS',
            data: {
              id: state.invoice && state.invoice.id,
              success: true,
            },
          })
        }
      } else if (action.method === 'alipay_hk') {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'ALIPAY_HK',
          url: action.pay_params_string
        }));
        Bridge.send({
          type: 'ALIPAY_HK',
          data: {
            id: state.invoice && state.invoice.id,
            type: action.type,
            method: action.method,
            pay_params: action.pay_params ? action.pay_params : {},
            pay_params_string: action.pay_params
              ? generateOrderStr(action.pay_params)
              : action.pay_params_string,
          },
        })
      } else {
        Bridge.send({
          type: 'QF_PAY',
          data: {
            id: state.invoice && state.invoice.id,
            type: action.type,
            method: action.method,
            pay_params: action.pay_params ? action.pay_params : {},
            pay_params_string: action.pay_params
              ? generateOrderStr(action.pay_params)
              : action.pay_params_string,
          },
        })
      }
      return {
        ...state,
      }
    }
    case FETCH_PAYMENT_STATUS_SUCCESS:
      Bridge.send({
        type: 'QF_PAY_STATUS',
        data: {
          id: state.invoice && state.invoice.id,
          success: true,
        },
      })
      return {
        ...state,
      }
    case FETCH_PAYMENT_STATUS_FAILURE:
      Bridge.send({
        type: 'QF_PAY_STATUS',
        data: {
          id: state.invoice && state.invoice.id,
          success: false,
        },
      })
      return {
        ...state,
      }
    case CHANGE_METHOD_SUCCESS:
      return {
        ...state,
        invoice: action.invoice,
      }
    default:
      return state
  }
}

export const getInvoice = (state) => {
  return state.invoice.invoice
}

export const getInvoices = (state) => {
  return state.invoice.invoices
}
